import { ArrowDown16, ArrowUp16 } from '@cian/ui-kit/icons';
import { Header4 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICollapse {
  isCollapsed: boolean;
  onClick(): void;
  header: string;
  headerClassName?: string;
}

export const Collapse = ({
  isCollapsed,
  onClick,
  header,
  headerClassName,
  children,
}: React.PropsWithChildren<ICollapse>) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <>
      <div className={classNames(styles.button, headerClassName)} onClick={handleClick}>
        <Header4>{header}</Header4>
        {isCollapsed ? <ArrowDown16 color={'gray60_100'} /> : <ArrowUp16 color={'gray60_100'} />}
      </div>
      <div
        className={classNames(styles.container, isCollapsed ? styles.collapsed : styles.expanded)}
        aria-expanded={!isCollapsed}
      >
        {children}
      </div>
    </>
  );
};
